import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class Global {
	menuList: any = [];
	userList: any = [];
	driveList: any = [];
	existUserList: any = [];
	domainList: any = [];
	allExistUserList: any = [];
	orgunitList: any = [];
	isUserListLoading = false;
	isExistUserListLoading = false;
	isGroupListLoading = false;
	isDomainListLoading = false;
    customReportDate: any = null;
	groupList: any = [];
    existUserLoadingObserver = new Subject<boolean>();
    groupLoadingObserver = new Subject<boolean>();
	constructor() {
        this.existUserLoadingObserver.subscribe((value) => {
            this.isExistUserListLoading = value;
        });
        this.groupLoadingObserver.subscribe((value) => {
            this.isGroupListLoading = value;
        });
	}

	isReadOnly(url) {
		for (let menu of this.menuList) {
			if(menu.children){
				for (let childrenMenu of menu.children) {
					if (childrenMenu.link == url) {
						if (childrenMenu.ATuserReadOnly == undefined || childrenMenu.ATuserReadOnly) return true;
						else if (childrenMenu.ATuserReadOnly == false) return false;
					}
				}
			}
		}

		return true;
    }
    
    toogleExistUserLoading(change) {
        this.existUserLoadingObserver.next(change);
    }
    
    toogleGroupLoading(change) {
        this.groupLoadingObserver.next(change);
    }
    
}